var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, CircularProgress, Grid } from "@mui/material";
import { useCallback, useEffect, useRef } from "react";
import { deleteState, pushToArray, setReducerState } from "../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { getLoadingKey, getUpdateKey } from "../../common/commonFunctions";
import { DynamicFormBuilderContainer } from "../dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
var InfiniteScroll = function (props) {
    var _crud$apiKey$data$len, _crud$apiKey, _crud$apiKey3;
    var crud = useAppSelector(function (state) { return state.crud; });
    var apiCall = props.apiCall, apiKey = props.apiKey, apiRequest = props.apiRequest, _a = props.threshold, threshold = _a === void 0 ? 0.0 : _a, _b = props.pageSize, pageSize = _b === void 0 ? 5 : _b, elements = props.elements, gridContainerProps = props.gridContainerProps, gridItemProps = props.gridItemProps, hasMore = props.hasMore;
    var dispatch = useAppDispatch();
    var loaderRef = useRef(null);
    var nextKey = apiKey + '_next';
    var updateKey = getUpdateKey(apiKey);
    var loadingKey = getLoadingKey(nextKey);
    var currLength = (_crud$apiKey$data$len = (_crud$apiKey = crud[apiKey]) === null || _crud$apiKey === void 0 || (_crud$apiKey = _crud$apiKey.data) === null || _crud$apiKey === void 0 ? void 0 : _crud$apiKey.length) !== null && _crud$apiKey$data$len !== void 0 ? _crud$apiKey$data$len : 0;
    var error = crud[apiKey] && (crud[apiKey].code != '200' && crud[apiKey].code != '201' || !crud[apiKey].success);
    var getData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _crud$apiKey2, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, apiCall({
                        key: nextKey,
                        request: _objectSpread(_objectSpread({}, apiRequest), {}, {
                            take: pageSize,
                            skip: currLength
                        })
                    })];
                case 1:
                    res = _a.sent();
                    if (!(res !== null && res !== void 0 && res.data))
                        return [2 /*return*/];
                    if (!((_crud$apiKey2 = crud[apiKey]) !== null && _crud$apiKey2 !== void 0 && (_crud$apiKey2 = _crud$apiKey2.data) !== null && _crud$apiKey2 !== void 0 && _crud$apiKey2.length)) {
                        dispatch(setReducerState({
                            key: apiKey,
                            value: res
                        }));
                    }
                    else {
                        dispatch(pushToArray({
                            key: apiKey,
                            value: res === null || res === void 0 ? void 0 : res.data
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [apiRequest, currLength, apiCall, pageSize]);
    useEffect(function () {
        var observer = new IntersectionObserver(function (_ref) {
            var entry = _ref[0];
            if (entry.isIntersecting && hasMore) {
                getData();
            }
        }, {
            threshold: threshold
        });
        var currentLoaderRef = loaderRef.current;
        if (currentLoaderRef) {
            observer.observe(currentLoaderRef);
        }
        return function () {
            if (currentLoaderRef) {
                observer.unobserve(currentLoaderRef);
            }
            dispatch(deleteState({
                key: nextKey
            }));
        };
    }, [hasMore, currLength, pageSize]);
    useEffect(function () {
        if (crud[updateKey]) {
            dispatch(deleteState({
                key: apiKey
            }));
            dispatch(deleteState({
                key: updateKey
            }));
        }
        return function () {
            if (!crud[updateKey]) {
                // dispatch(deleteState({ key: apiKey }))
                dispatch(deleteState({
                    key: nextKey
                }));
                dispatch(deleteState({
                    key: updateKey
                }));
            }
        };
    }, [crud[updateKey]]);
    return /*#__PURE__*/ React.createElement(Grid, _extends({
        container: true
    }, gridContainerProps), (_crud$apiKey3 = crud[apiKey]) === null || _crud$apiKey3 === void 0 || (_crud$apiKey3 = _crud$apiKey3.data) === null || _crud$apiKey3 === void 0 ? void 0 : _crud$apiKey3.map(function (item) { return (elements === null || elements === void 0 ? void 0 : elements.length) && /*#__PURE__*/ React.createElement(Grid, _extends({
        item: true
    }, gridItemProps), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: elements,
        state: item,
        gridSpacing: 0
    })); }), hasMore && !error && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Box, {
        ref: loaderRef,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: 40,
        width: "100%"
    }, crud[loadingKey] === 'loading' && /*#__PURE__*/ React.createElement(CircularProgress, {
        size: 20
    }))));
};
export default InfiniteScroll;
